$.eachComponent('.general-languages', function(context) {
    $('select[name="fk_languages"]', context).change(function(){
        $('input[name="reload"]').click();
    });
});


